export default __webpack_public_path__ + "static/media/Opposites02_16.887365d6.png";